import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { fetchRoomDisplay } from '../services/partyScreenApi';
import { normalizeScreenStyle } from '../constants/screenStyles';
import { isRoomEntryGranted } from '../constants/roomAccess';
import RoomPasswordGate from '../components/RoomPasswordGate';
import ServiceCallPanel from '../components/ServiceCallPanel';
import './RoomDisplay.css';
import './RoomDisplay.themes.css';

export default function RoomService() {
  const { roomId } = useParams();
  const navigate = useNavigate();
  const [roomInfo, setRoomInfo] = useState(null);
  const [screenStyle, setScreenStyle] = useState('warm');
  const [loading, setLoading] = useState(true);
  const [entryGranted, setEntryGranted] = useState(() => isRoomEntryGranted());

  useEffect(() => {
    if (!entryGranted) return undefined;
    let cancelled = false;
    const load = async () => {
      try {
        const data = await fetchRoomDisplay(roomId);
        if (!cancelled) {
          setRoomInfo(data?.room || null);
          setScreenStyle(normalizeScreenStyle(data?.screen_style));
        }
      } catch {
        if (!cancelled) setRoomInfo(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    const poll = setInterval(load, 3000);
    return () => {
      cancelled = true;
      clearInterval(poll);
    };
  }, [roomId, entryGranted]);

  if (!entryGranted) {
    return (
      <div className="room-display-page room-display-page--empty">
        <RoomPasswordGate
          open
          onCancel={() => navigate('/')}
          onSuccess={() => setEntryGranted(true)}
        />
      </div>
    );
  }

  if (!loading && !roomInfo) {
    return (
      <div className="room-display-page room-display-page--empty">
        <p>未找到该房间</p>
        <Link to="/">返回房间列表</Link>
      </div>
    );
  }

  return (
    <div className={`room-display-page theme-${screenStyle} room-display-page--service-focus`}>
      <div className="room-display-bg" />

      <div className="display-top">
        <header className="display-header">
          <div className="display-header-brand">
            <Link to={`/room/${roomId}`} className="back-btn">
              返回大屏
            </Link>
            <div className="display-logo-slot" aria-hidden="true">
              <div className="display-logo-placeholder">
                <span className="display-logo-placeholder-mark">呼叫服务</span>
              </div>
            </div>
          </div>
          <div className="display-header-meta">
            {roomInfo ? (
              <div className="display-room-line">
                <span className="display-room-line-item display-room-line-name">{roomInfo.name}</span>
                {roomInfo.store_name ? (
                  <>
                    <span className="display-room-line-sep">·</span>
                    <span className="display-room-line-item">{roomInfo.store_name}</span>
                  </>
                ) : null}
              </div>
            ) : null}
          </div>
        </header>
      </div>

      <div className="service-focus-body">
        <ServiceCallPanel roomId={roomId} variant="focus" />
      </div>
    </div>
  );
}
